import { render, staticRenderFns } from "./KursDetails.vue?vue&type=template&id=d6ca1d32"
import script from "./KursDetails.vue?vue&type=script&lang=js"
export * from "./KursDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports